<div class="flex-content">
  <div class="content col-sm container-fluid">
    <div class="front-image-max">
      <img src="./../../../../assets/Contents/imgs/sponsorship.png">
      <div class="front-title">
        <h2>Thank you for your support!!</h2>
      </div>
    </div>

    <div class="row desc-box no-gutters">
      <div class="sponser-box col-12 col-sm-3">
        <div class="sponser-title text-center">
          <sub>Donate over 1,000,000 won</sub>
          <h5>Platinum Award</h5>
        </div>

        <div *ngFor="let sponsers of platinum$ | async" class="sponser-name text-center">
          <sub>{{sponsers[0].year}}</sub>
          <p (click)= 'navigateTo(spon.sponsor_id, spon.link, spon.type)' class="spon" *ngFor="let spon of sponsers">{{spon.name}}</p>
        </div>

      </div>

      <div class="sponser-box col-12 col-sm-3 ">
        <div class="sponser-title text-center">
          <sub>Donate over 500,000 won</sub>
          <h5>Gold Award</h5>
        </div>
        <div *ngFor="let sponsers of gold$ | async" class="sponser-name text-center">

          <sub>{{sponsers[0].year}}</sub>
          <p (click)= 'navigateTo(spon.sponsor_id, spon.link, spon.type)' class="spon" *ngFor="let spon of sponsers">{{spon.name}}</p>
        </div>
      </div>

      <div class="sponser-box col-12 col-sm-3 ">
        <div class="sponser-title text-center">
          <sub>Donate over 100,000 won</sub>
          <h5>Silver Award</h5>
        </div>
        <div *ngFor="let sponsers of silver$ | async" class="sponser-name text-center">
          <sub>{{sponsers[0].year}}</sub>
          <p (click)= 'navigateTo(spon.sponsor_id, spon.link, spon.type)' class="spon" *ngFor="let spon of sponsers">{{spon.name}}</p>
        </div>

      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/about-sponser/about-sponser.component.html